import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { SavedReportsProps } from './SavedReports.props';
import { ContentWrapperBox, HeadingWrapper, Footer, StyledButton } from './SavedReports.styles';
import { EMPTY_NAME_FIELD_MESSAGE } from '../../../constants/common';
import { generateUniqueCode, isEmptyString } from '../../../utils/common';
import { ButtonColorProps, ButtonVariantProps } from '../../atoms/Button';
import { CloseIcon } from '../../atoms/CloseIcon';
import { Modal } from '../../atoms/Modal';
import { TextField } from '../../atoms/TextField';
import { TypographyVariantProps } from '../../atoms/Typography';

export const SavedReports: React.FC<SavedReportsProps> = ({
  open,
  handleClose,
  newReportData,
  updateColumnData,
  enableOverWrite,
  handleSave,
  handleOverwrite
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const savedReportCode = queryParams.get('savedReportCode');
  const [reportName, setReportName] = useState('');
  const [nameRequiredError, setNameRequiredError] = useState(false);

  useEffect(() => {
    newReportData.reportName && setReportName(newReportData.reportName);
  }, [newReportData?.reportName]);

  const onCancel = () => { 
    setNameRequiredError(false);
    handleClose();
  };

  const onSave = () => {
    const uniqueCode = generateUniqueCode();

    const savedReportData = {
      name: reportName,
      code: uniqueCode,
      reportTypeName: newReportData?.reportTypeName,
      isDefault: false,
      dataGridProperties: newReportData?.dataGridProperties,
      columnSelection: updateColumnData?.columnSelection
    };

    if (isEmptyString(reportName)) {
      setNameRequiredError(true);
    } else {
      setNameRequiredError(false);
      handleSave(savedReportData);
    }    
  };

  const onOverwrite = () => {   
    const overwriteReportData = {
      name: reportName,
      isDefault: false,
      dataGridProperties: newReportData?.dataGridProperties,
      columnSelection: updateColumnData?.columnSelection
    };

    if (isEmptyString(reportName)) {
      setNameRequiredError(true);
    }
    else{
      setNameRequiredError(false);
      handleOverwrite(overwriteReportData);
    }
  };
 
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <ContentWrapperBox>
        <CloseIcon handleClose={handleClose} />
        <HeadingWrapper variant={TypographyVariantProps.H6}>
          Enter Report Name
        </HeadingWrapper>
        <Grid>
          <Grid size={{ xs: 9 }}>
            <TextField
              fullWidth
              value={reportName}
              onChange={(value) => { 
                setReportName(value);
                setNameRequiredError(false);
              }}
              helperText={nameRequiredError ? EMPTY_NAME_FIELD_MESSAGE : ''}
              error={nameRequiredError}
            />
          </Grid>
          <Grid>
            <Footer>
              <StyledButton variant={ButtonVariantProps.Secondary} onClick={onCancel}>Close</StyledButton>
              {savedReportCode && enableOverWrite &&
                <StyledButton color={ButtonColorProps.Error} onClick={onOverwrite}>Overwrite Existing Report</StyledButton>
              }
              <StyledButton variant={ButtonVariantProps.Primary} onClick={onSave}>{savedReportCode ? 'Save as New Report' : 'Save'}</StyledButton>
            </Footer>
          </Grid>
        </Grid>
      </ContentWrapperBox>
    </Modal>
  );
};